<div class="background-login">
  <!-- <img class="grupo-saesa-logo" src="assets/images/grupo-saesa-white-original.png"/> -->

  <!-- FORM -->
  <div class="col-6-md col-6-lg col-6-xl col-12-xs content-form" style="padding-top: 50vh">
    <!-- <div class="row">
      <div class="col-12 text-center">
        <img
          src="assets/images/saesa-worker.png"
          style="margin: 0; height: 180px; width: 132.9px; margin-bottom: -30px"
        />
      </div>
      <div class="col-12 text-center">
        <img
          src="assets/images/rmcap-logo.png"
          style="
            margin: 0;
            height: 141px;
            width: 366.76px;
            margin-bottom: -30px;
          "
        />
      </div>
    </div> -->
    <div style="text-align: center">
      <!-- <img class="left-bracket-logo" src="assets/images/left_bracket.png"> -->
      <form
        class="form-login"
        [formGroup]="registerForm"
        (ngSubmit)="onSubmit()"
      >
        <!-- <label style="color: white; font-size: 2em">Bienvenidos</label>
        <p class="text-cap">RMCAP 2.0</p> -->
        <div class="form-group mb-sm-3 mr-2 col-12 col-lg-12">
          <div class="form-group row mt-3 position-relative">
            <div class="col-12">
              <span class="input-names">Usuario</span>
            </div>
            <div class="col-12">
              <span class="input-icon material-icons-outlined"> mail </span>
              <input
                formControlName="user"
                [value]="loginData.user"
                (change)="changeInput('user', $event.target.value, 'string')"
                type="text"
                class="form-control input-text mainLoginInput"
                [ngClass]="{ 'is-invalid': submitted && f['user'].errors }"
                placeholder="Ingresa tu nombre de Usuario"
              />
            </div>
            <div
              *ngIf="submitted && f['user'].errors"
              class="col-12 invalid-feedback"
            >
              <div *ngIf="f['user'].errors.required">
                Usuario es obligatorio
              </div>
            </div>
          </div>
          <div class="form-group row mt-3 position-relative">
            <div class="col-12">
              <span class="input-names">Contraseña</span>
            </div>
            <div class="col-12">
              <span class="input-icon material-icons-outlined"> key </span>
              <input
                type="password"
                formControlName="password"
                [value]="loginData.password"
                class="form-control input-text mainLoginInput"
                (change)="changeInput('password', $event.target.value, 'string')"
                [ngClass]="{
                  'is-invalid': submitted && f['password'].errors
                }"
                placeholder="Ingresa tu contraseña"
              />
            </div>
            <label *ngIf="!success" style="color: white"
              >Error al validar correo y contraseña!</label
            >
            <div
              *ngIf="submitted && f['password'].errors"
              class="invalid-feedback"
            >
              <div *ngIf="f['password'].errors.required">
                La contraseña es obligatoria
              </div>
            </div>
          </div>

          <div class="form-group row mt-3">
            <div class="col-12 d-flex">
              <button class="btn ingresar-button">Iniciar Sesión</button>
            </div>
          </div>
        </div>
      </form>
      <!-- <img class="right-bracket-logo" src="assets/images/left_bracket.png"> -->
    </div>
  </div>
  <!-- FORM END -->
</div>
